import pages from './pages';
import { NavItemType } from 'types/menu';

const menuItems: { items: NavItemType[] } = {
  items: [pages]
};

export default menuItems;
